import { useMemo } from 'react';

import { useCanInviteMember, useIsSpaceOwner } from '@/features/teamspace';

import { useDeleteUserFromSpace, useInviteUserToSpace } from '@/entities/teamspace';
import { useDeleteInvitedUserFromSpace } from '@/entities/teamspace/model/useGetSpaces';

import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';
import { SpaceDetails } from '@/shared/types/Space';

export const useTeamspaceMembersModel = (space?: SpaceDetails) => {
  const isOwner = useIsSpaceOwner();
  const { isPending: isInvitingMember, mutateAsync: inviteMember } = useInviteUserToSpace(space?.id || '');
  const { isPending: isDeletingUser, mutateAsync: deleteUserFromSpace } = useDeleteUserFromSpace(space?.id || '');
  const { isPending: isDeletingInvitedUser, mutateAsync: deleteInvitedUserFromSpace } = useDeleteInvitedUserFromSpace(
    space?.id || '',
  );
  const members = useMemo(() => [...(space?.members || []), ...(space?.invites || [])], [space]);

  const canInviteMember = useCanInviteMember();

  const onInviteMember = async (email: string) => {
    if (!canInviteMember) return;

    await inviteMember({ emails: [email] });
  };

  const onRemoveMember = async (id: string) => {
    await deleteUserFromSpace(id);
    MixpanelEvents.removeMemberSpace();
  };

  const onRemoveInvitedMember = async (id: string) => {
    await deleteInvitedUserFromSpace(id);
    MixpanelEvents.removeMemberSpace();
  };

  return {
    canInviteMember,
    isDeletingUser: isDeletingUser || isDeletingInvitedUser,
    isInvitingMember,
    isOwner,
    members,
    onInviteMember,
    onRemoveInvitedMember,
    onRemoveMember,
  };
};
